import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { useState } from 'react';
import type { TableOfContentsHeadingProps } from '../types';
type Props = {
  headings: TableOfContentsHeadingProps[];
};
export const useTableOfContents = t0 => {
  const $ = _c(4);
  const {
    headings
  } = t0;
  const [activeId, setActiveId] = useState(headings[0].id);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      actionName: "toc_interacted",
      actionSection: "table_of_contents",
      actionType: "navigate"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const fireNavigateToSectionPageAction = usePageAction(t1);
  let t2;
  if ($[1] !== activeId || $[2] !== fireNavigateToSectionPageAction) {
    t2 = {
      activeId,
      setActiveId,
      fireNavigateToSectionPageAction
    };
    $[1] = activeId;
    $[2] = fireNavigateToSectionPageAction;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};